module.exports = __webpack_public_path__ + "static/img/20200828121618.6d36a76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/20200828121618.jpg
// module id = 0B63
// module chunks = 0